"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationPanelHeaderWithImages = exports.IntegrationPanelHeaderTitle = exports.IntegrationPanelBodyWithToggleSetting = exports.InputValidationError = void 0;
exports.getIntegrationPanel = getIntegrationPanel;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PanelItems = require("../PanelItems");

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _classnames = _interopRequireDefault(require("classnames"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _utils = require("../../utils");

var IntegrationPanelHeaderWithImages = function IntegrationPanelHeaderWithImages(_ref) {
  var title = _ref.title,
      statusText = _ref.statusText,
      meta = _ref.meta,
      imageFromName = _ref.imageFromName,
      imageToName = _ref.imageToName,
      customClass = _ref.customClass;
  var basePath = (0, _utils.sanitizeUrl)((0, _globals.default)('basePath'));
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('panel-header__wrapper', (0, _defineProperty2.default)({}, "".concat(customClass !== null && customClass !== void 0 ? customClass : ''), customClass))
  }, (0, _preact.h)("div", {
    className: "panel-header__logo_wrapper"
  }, imageFromName && (0, _preact.h)("div", {
    className: "panel-header__logo"
  }, (0, _preact.h)("img", {
    height: 32,
    width: 32,
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat(basePath, "images/integrations/").concat(imageFromName, ".png"))
  })), imageToName && (0, _preact.h)("div", {
    className: "panel-header__direction_icon"
  }, (0, _preact.h)(_assets.default, {
    icon: "arrowRight",
    width: 20,
    height: 20,
    customClass: "integration-direction-icon"
  })), imageToName && (0, _preact.h)("div", {
    className: "panel-header__logo"
  }, (0, _preact.h)("img", {
    height: 32,
    width: 32,
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat(basePath, "images/integrations/").concat(imageToName, ".png"))
  }))), (0, _preact.h)("div", {
    className: "panel-header-title-wrapper"
  }, (0, _preact.h)("div", {
    className: "panel-header-title"
  }, title, statusText && (0, _preact.h)("span", {
    className: "panel-header-status status-".concat(statusText)
  }, statusText)), meta && (0, _preact.h)("div", {
    className: "panel-header-meta"
  }, meta)));
};

exports.IntegrationPanelHeaderWithImages = IntegrationPanelHeaderWithImages;

var IntegrationPanelHeaderTitle = function IntegrationPanelHeaderTitle(_ref2) {
  var isInstalled = _ref2.isInstalled,
      storedIsSettingEnabled = _ref2.storedIsSettingEnabled,
      title = _ref2.title,
      imageFromName = _ref2.imageFromName,
      imageToName = _ref2.imageToName,
      customClass = _ref2.customClass;
  return (0, _preact.h)(IntegrationPanelHeaderWithImages, {
    title: title,
    statusText: isInstalled && storedIsSettingEnabled && 'on' || isInstalled && !storedIsSettingEnabled && 'off' || undefined,
    imageFromName: imageFromName,
    imageToName: imageToName,
    customClass: customClass
  });
};

exports.IntegrationPanelHeaderTitle = IntegrationPanelHeaderTitle;

var IntegrationPanelBodyWithToggleSetting = function IntegrationPanelBodyWithToggleSetting(_ref3) {
  var isInstalled = _ref3.isInstalled,
      isSettingEnabled = _ref3.isSettingEnabled,
      _onSave = _ref3.onSave,
      _onCancel = _ref3.onCancel,
      _onSettingChanged = _ref3.onSettingChanged,
      showActionButtons = _ref3.showActionButtons,
      communityArticleLink = _ref3.communityArticleLink,
      description = _ref3.description,
      additionalHelpText = _ref3.additionalHelpText,
      toggleLabel = _ref3.toggleLabel,
      additionalInputFields = _ref3.additionalInputFields,
      integrationStatus = _ref3.integrationStatus,
      storedIsSettingEnabled = _ref3.storedIsSettingEnabled,
      isLoading = _ref3.isLoading,
      additionalHelpTextBelowToggle = _ref3.additionalHelpTextBelowToggle;
  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)("div", {
    className: "panel-body-instructions"
  }, description), isInstalled && additionalInputFields, isInstalled && (0, _preact.h)(_PanelItems.ToggleWithLabel, {
    label: toggleLabel,
    isToggleEnabled: isSettingEnabled,
    onSettingChanged: function onSettingChanged() {
      return _onSettingChanged(!isSettingEnabled);
    }
  }), isInstalled && storedIsSettingEnabled && additionalHelpTextBelowToggle ? (0, _preact.h)("div", {
    className: "help-text-wrapper below-toggle"
  }, additionalHelpTextBelowToggle, " ") : null, integrationStatus, storedIsSettingEnabled ? (0, _preact.h)("div", {
    className: "help-text-wrapper"
  }, ' ', "\uD83D\uDE4C ", (0, _preact.h)("span", {
    className: "text--bold"
  }, "What\u2019s next:"), " ", additionalHelpText, ' ') : null, communityArticleLink && (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "Learn more about this integration",
    url: communityArticleLink,
    isExternalLinkForToggle: false
  }), showActionButtons && (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    },
    isLoading: isLoading
  }));
};

exports.IntegrationPanelBodyWithToggleSetting = IntegrationPanelBodyWithToggleSetting;

var InputValidationError = function InputValidationError(_ref4) {
  var message = _ref4.message;
  return (0, _preact.h)("div", {
    className: "error-message-container"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
    customClass: "icon-warning",
    icon: "warning"
  })), (0, _preact.h)("div", {
    className: "error-message-text"
  }, message));
};

exports.InputValidationError = InputValidationError;

function getIntegrationPanel(props) {
  var isInstalled = props.isInstalled,
      isSettingEnabled = props.isSettingEnabled,
      title = props.title,
      imageFromName = props.imageFromName,
      imageToName = props.imageToName,
      _onSave2 = props.onSave,
      _onCancel2 = props.onCancel,
      _onSettingChanged2 = props.onSettingChanged,
      showActionButtons = props.showActionButtons,
      toggleLabel = props.toggleLabel,
      communityArticleLink = props.communityArticleLink,
      description = props.description,
      storedIsSettingEnabled = props.storedIsSettingEnabled,
      hasUnsavedChanges = props.hasUnsavedChanges,
      _onClickPanel = props.onClickPanel,
      customClass = props.customClass,
      additionalHelpText = props.additionalHelpText,
      additionalHelpTextBelowToggle = props.additionalHelpTextBelowToggle,
      integrationStatus = props.integrationStatus,
      additionalInputFields = props.additionalInputFields,
      isLoading = props.isLoading;
  return {
    title: (0, _preact.h)(IntegrationPanelHeaderTitle, {
      isInstalled: isInstalled,
      storedIsSettingEnabled: storedIsSettingEnabled,
      title: title,
      imageFromName: imageFromName,
      imageToName: imageToName
    }),
    body: (0, _preact.h)(IntegrationPanelBodyWithToggleSetting, {
      isInstalled: isInstalled,
      isSettingEnabled: isSettingEnabled,
      onSettingChanged: function onSettingChanged() {
        return _onSettingChanged2(!isSettingEnabled);
      },
      onSave: function onSave() {
        return _onSave2();
      },
      onCancel: function onCancel() {
        return _onCancel2();
      },
      showActionButtons: showActionButtons,
      toggleLabel: toggleLabel,
      communityArticleLink: communityArticleLink,
      description: description,
      additionalHelpText: additionalHelpText,
      additionalHelpTextBelowToggle: additionalHelpTextBelowToggle,
      integrationStatus: integrationStatus,
      storedIsSettingEnabled: storedIsSettingEnabled,
      additionalInputFields: additionalInputFields,
      isLoading: isLoading
    }),
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: "integration__panel ".concat(customClass !== null && customClass !== void 0 ? customClass : ''),
    onClickPanel: function onClickPanel(selectedPanel) {
      return _onClickPanel(selectedPanel);
    }
  };
}